import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  StoreForClientInvoiceUIResponse
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { StoreResponseForClientInvoice } from "../../models/responseModels/ClientInvoiceResponses";

type InitialState = {
  isLoading: boolean;
  storesForCurrentClientInvoice: StoreResponseForClientInvoice[]; // stores for current client invoice
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  storesForCurrentClientInvoice: [],
  errorMessage: null,
};

export const getStoresForCurrentClientInvoice = createAsyncThunk<
  StoreForClientInvoiceUIResponse,
  string
>(
  "client-invoice/stores-for-current-client-invoice-response",
  async (clientInvoiceId: string) => {
    const response = await agent.ClientInvoiceAgent.getStoresForClientInvoice(
      clientInvoiceId
    );
    return response;
  }
);

const clientInvoiceSlice = createSlice({
  name: "clientInvoice",
  initialState,
  reducers: {
    clearStoresForCurrentClientInvoice: (state) => {
      state.storesForCurrentClientInvoice = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // STORES FOR CURRENT CLIENT INVOICE
      .addCase(getStoresForCurrentClientInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStoresForCurrentClientInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.storesForCurrentClientInvoice = action.payload.data;
        } else {
          state.storesForCurrentClientInvoice = [];
        }
      })
      .addCase(getStoresForCurrentClientInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.storesForCurrentClientInvoice = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default clientInvoiceSlice.reducer;
export const { clearStoresForCurrentClientInvoice } =
  clientInvoiceSlice.actions;
